/**
 * External Dependencies
 */
//import 'jquery';
import 'bootstrap';

import {gsap, Power1, Power2, Power3} from 'gsap';
//import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import LazyLoad from 'vanilla-lazyload';
import ScrollAnimations from './ScrollAnimations';  // importing here our supercool Riot scroll animations framewok
import 'slick-carousel/slick/slick.min.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.js';
import 'sharer.js/sharer.min.js';


// function needed for CF7, alongside custom css in forms.scss, this is just to add a class when field is not empty, to keep label on top
function floatingLabelsFix() {

  var $inputs = $(".form-floating input, .form-floating textarea");
  $inputs.on("input", function() {
    var $filled = $inputs.filter(function() { return this.value.trim().length > 0; });
    $(this).parent().toggleClass('floating-filled', $filled.length > 0);
  });
}



function startSlick() {
  $('.home-hero').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    fade: true,
    speed: 500,
    cssEase: "ease",
    useTransform: true,
    //fade: true,
    asNavFor: '.home-hero-nav',


  });
  $('.home-hero-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.home-hero',
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    mobileFirst: true,
    useTransform: true,
    speed: 300,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      }
    ]
  });

}



// generic smooth scroll anchor animation
function smoothScroll() {

  $(document).on('click', 'a[href^="#"]:not(.playstation5, .xboxseriesx, .playstation, .xbox, .pc, .switch, .nav-tabs a)', function (event) {
      event.preventDefault();
      $('html, body').animate({  scrollTop: $($.attr(this, 'href')).offset().top }, 1500);
  });

}


$( document ).ready(function() {


    // JavaScript to be fired on all pages


    // make data-href work as links (for main menu items with dropdowns)
    // document.querySelectorAll('[data-href]').forEach( e,
    //   function () {
    //    e.addEventListener('click', function () {
    //       console.log ('clicked');
    //       window.location.href = e.getAttribute('data-href');
    //   });
    // });

    // document.querySelectorAll('[data-href]').forEach((e)=>{
    //   e.addEventListener('click', ()=>{
    //     console.log('click');
    //     window.location.href = e.getAttribute('data-href');
    //   })
    // })
    

     // offanvas menu mechanism, added on top of default collapse menu
    document.querySelector('[data-bs-toggle="offcanvas"]').addEventListener('click', function () {
    document.querySelector('.offcanvas-collapse').classList.toggle('open');


      if (this.getAttribute('aria-expanded') == 'false') {
        this.setAttribute('aria-expanded', 'true');
        document.body.setAttribute('aria-expanded', 'true');
      } else {
        this.setAttribute('aria-expanded', 'false');
        document.body.setAttribute('aria-expanded', 'false');
      }
    })







     /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
     var prevScrollpos = window.pageYOffset;
     window.onscroll = function() {

       var currentScrollPos = window.pageYOffset;

       let currentMenuHeight = document.getElementById("main-navigation").clientHeight;

       if (prevScrollpos > currentScrollPos ) {
         document.getElementById("main-navigation").style.top = "0";

       } else {
         if (currentScrollPos >= 50){
         document.getElementById("main-navigation").style.top = "-" + currentMenuHeight + "px";
         }
       }
       if (currentScrollPos >= 50) {
         $('#main-navigation').addClass('scrolling');

       } else {
           $('#main-navigation').removeClass('scrolling');
       }
       prevScrollpos = currentScrollPos;

     }



    new ScrollAnimations();


    smoothScroll();

    startSlick();

    floatingLabelsFix();

    $( ".gallery a, .wp-block-gallery a" ).attr('data-fancybox', 'gallery').attr('data-width', '1600');
    $('[data-fancybox]').fancybox({
    youtube : {
            controls : 1,
            showinfo : 0,
        },
        vimeo : {
            color : 'f00',
        },
    });

    // initialize vanilla-lazyload
    var lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy'
    });


});
